import { useTheme } from "@mui/system";

// Иконка раздела "Diagnocat": зуб с рамкой снимка - отчёты по КЛКТ и
// внутриротовым снимкам. Стиль тот же, что у остальных medCardPageIcons -
// плоский svg, цвет из theme.palette.rgd.primary.
export default function DiagnocatIcon({ size = 40 }) {
  const theme = useTheme();

  const baseWidth = 40;
  const baseHeight = 40;

  // Иконка квадратная, поэтому масштабируется по size целиком (в SectionCard она
  // растягивается до ширины контейнера, в списке уведомлений вызывается с size={20})
  const height = (baseHeight * size) / baseWidth;

  return (
    <svg
      width={size}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Рамка снимка */}
      <path
        d="M3 1H37C38.1046 1 39 1.89543 39 3V37C39 38.1046 38.1046 39 37 39H3C1.89543 39 1 38.1046 1 37V3C1 1.89543 1.89543 1 3 1ZM3.4 3.4V36.6H36.6V3.4H3.4Z"
        fill={theme.palette.rgd.primary}
      />

      {/* Уголки кадрирования */}
      <path
        d="M6.5 6.5H12V8.4H8.4V12H6.5V6.5ZM28 6.5H33.5V12H31.6V8.4H28V6.5ZM6.5 28H8.4V31.6H12V33.5H6.5V28ZM31.6 28H33.5V33.5H28V31.6H31.6V28Z"
        fill={theme.palette.rgd.primary}
      />

      {/* Зуб */}
      <path
        d="M20 11.5C21.1 11.5 21.9 11.95 22.9 11.95C23.85 11.95 24.4 11.5 25.35 11.5C27.5 11.5 29.2 13.4 29.2 16.35C29.2 18.9 28.4 21.4 27.35 23.9C26.75 25.35 26.3 26.75 25.95 28.15C25.7 29.15 25.4 29.9 24.55 29.9C23.6 29.9 23.35 28.95 23.15 27.65C22.9 26.05 22.6 24.1 21.6 23.35C21.15 23.05 20.6 22.9 20 22.9C19.4 22.9 18.85 23.05 18.4 23.35C17.4 24.1 17.1 26.05 16.85 27.65C16.65 28.95 16.4 29.9 15.45 29.9C14.6 29.9 14.3 29.15 14.05 28.15C13.7 26.75 13.25 25.35 12.65 23.9C11.6 21.4 10.8 18.9 10.8 16.35C10.8 13.4 12.5 11.5 14.65 11.5C15.6 11.5 16.15 11.95 17.1 11.95C18.1 11.95 18.9 11.5 20 11.5ZM20 13.9C19.35 13.9 18.75 14.35 17.1 14.35C15.9 14.35 15.4 13.9 14.65 13.9C13.75 13.9 13.2 14.75 13.2 16.35C13.2 18.35 13.9 20.55 14.85 22.95C15.15 23.7 15.4 24.4 15.65 25.1C15.95 23.75 16.45 22.25 17.7 21.35C18.45 20.8 19.25 20.5 20 20.5C20.75 20.5 21.55 20.8 22.3 21.35C23.55 22.25 24.05 23.75 24.35 25.1C24.6 24.4 24.85 23.7 25.15 22.95C26.1 20.55 26.8 18.35 26.8 16.35C26.8 14.75 26.25 13.9 25.35 13.9C24.6 13.9 24.1 14.35 22.9 14.35C21.25 14.35 20.65 13.9 20 13.9Z"
        fill={theme.palette.rgd.primary}
      />
    </svg>
  );
}
